const LANG_STORAGE_KEY = "lang";

const LANG_ALIASES = {
    pt: "ptBr",
    "pt-br": "ptBr",
    ptbr: "ptBr",
    en: "en",
    "en-us": "en",
    "en-gb": "en",
    es: "es",
    "es-es": "es",
    "es-mx": "es",
};

export const normalizeLang = (lang) => {
    if (!lang || typeof lang !== "string") {
        return null;
    }

    const normalized = lang.trim().toLowerCase().replace(/_/g, "-");
    return LANG_ALIASES[normalized] || null;
};

export const getStoredLang = () => {
    try {
        return normalizeLang(window.localStorage.getItem(LANG_STORAGE_KEY));
    } catch (error) {
        return null;
    }
};

export const persistLang = (lang) => {
    try {
        window.localStorage.setItem(LANG_STORAGE_KEY, lang);
    } catch (error) {
        // Ignore storage failures and keep the app usable.
    }
};

export const getBrowserDefaultLang = () => {
    const userLang = navigator.language || navigator.userLanguage;
    return normalizeLang(userLang) || "ptBr";
};

export const getRouteLang = (route) => normalizeLang(route?.query?.lang);

export const resolveInitialLang = (route) => {
    const queryLang = getRouteLang(route);
    if (queryLang) {
        persistLang(queryLang);
        return queryLang;
    }

    return getStoredLang() || getBrowserDefaultLang();
};
